import VueRouter from 'vue-router';

// If you need to add more pages add the component in the views folder and import them bellow
// Vue Templates
import Home from '@/views/Home.vue';
import MapContainer from '@/components/MapContainer.vue';

const routes = [
    {
        path: '/locator',
        component: MapContainer,
        name: 'MapContainer',
    },
    {
        path: '/*',
        component: Home,
        name: 'Home',
    },
];

const router = new VueRouter({
    base: '/',
    mode: 'history',
    routes,
});

export default router;
